module.exports = __webpack_public_path__ + "img/android.e9eaf98c.svg";